import { LOAD_SHOP_LIST_VIEW } from "../constants/reduxActions"

export const openShopListView = (showMap) => {
  return {
    type: LOAD_SHOP_LIST_VIEW,
    showMap
  }
}
